import { Trash2 } from "lucide-react";
import React, { useEffect, useState } from "react";
import { ActionIcon } from "@mantine/core";
import { HttpClientError } from "../../../providers/HttpClient";
import { queryClient } from "../../../App";
import ConfirmDeleteModel from "../../../themes/elements/ConfirmDeleteModel";
import useDeleteTagApiService from "../services/api/DeleteTagApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

type TagDeleteActionButtonProps = {
  id: number;
};

const TagDeleteActionButton: React.FC<TagDeleteActionButtonProps> = ({
  id,
}) => {
  const [opened, setOpened] = useState(false);
  const { isLoading, isError, error, isSuccess, mutateAsync } =
    useDeleteTagApiService();
  const { showToast } = useToasts();

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "tag_delete_failed",
        data: {
          message: HttpClientError(error),
        },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({ strapiId: "tag_delete_success" });

      queryClient.invalidateQueries("TagsCategoryListApiService").then();
    }
  }, [isSuccess]);

  return (
    <>
      <ConfirmDeleteModel
        isLoading={isLoading}
        onConfirm={() =>
          mutateAsync(id).then(() => {
            setOpened(false);
            // navigate("/employees#tags", { replace: true });
          })
        }
        label="tag"
        onClose={() => setOpened(false)}
        opened={opened}
      />
      <ActionIcon onClick={() => setOpened(true)}>
        <Trash2 size={18} />
      </ActionIcon>
    </>
  );
};

export default TagDeleteActionButton;
